export const closeNotification = (dispatch, actionType) => {
    dispatch({
        type: actionType,
        dispatcher: dispatch
    })
};